import type { FunctionComponent, SVGProps } from 'react';

export type IconSkillsProps = SVGProps<SVGSVGElement> & {
    readonly className?: string;
    readonly fill?: string;
    readonly height?: number | string;
    readonly width?: number | string;
};

export const IconSkills: FunctionComponent<IconSkillsProps> = ({
    className = '',
    fill = 'currentColor',
    height = 16,
    width = 16,
    ...props
}) => {
    return (
        // biome-ignore lint/a11y/noSvgWithoutTitle: suppressed due to migration
        <svg
            className={className}
            fill="none"
            height={height}
            viewBox="0 0 24 24"
            width={width}
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path d="M6.55 3.9Q7 3 7.45 3.9L10.55 10.1Q11 11 10 11H4Q3 11 3.45 10.1Z" fill={fill} />
            <rect fill={fill} height="8" rx="1" width="8" x="3" y="13" />
            <circle cx="17" cy="17" fill={fill} r="4" />
            <rect fill={fill} height="4" rx="1" width="8" x="13" y="5" />
        </svg>
    );
};
